module.exports = __webpack_public_path__ + "img/newLogoSide.aadeba32.png";